export const API_CONSTANT_MAP = {
  baseUrl: process.env.REACT_APP_API_URL,
  menuItens: "Menu",
  usuario: "Usuario",
  unidade: "Unidade",
  perfil: "Perfil",
  login: "Login",
  loginRenew: "Login/renew",
  turma: "Turma",
  aluno: "Aluno",
  pagamento: "Pagamento",
  escolaEnsinoMedio: "EscolaEnsinoMedio",
  tipoIndicacao: "TipoIndicacao",
  cep: "Api/Cep",
  orcamentoPublico: "Api/OrcamentoPublico",
  periodoLetivo: "PeriodoLetivo",
  servico: "Servico",
  produto: "Produto",
  categoriaProduto: "CategoriaProduto",
  venda: "Venda",
  especifica: "Especifica",
  pessoa: "Pessoa",
  gradeHoraria: "GradeHoraria",
  cheque: "Cheque",
  dinheiro: "Dinheiro",
  cartao: "Cartao",
  boleto: "Boleto",
  pix: "Pix",
};
